import { Component, inject, Input, OnInit } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { Contact } from 'app/core/model/contact';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';
import { ContactRole } from 'app/core/model/contact-role';
import { onToolbarPreparing } from 'app/core/utility';

@Component({
    selector: 'app-contact-grid',
    template: `
        <dx-data-grid [height]="500" #dataGrid [dataSource]="contacts" keyExpr="id" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="name" width="150"></dxi-column>
            <dxi-column dataField="phone" width="125"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>
            <dxi-column dataField="displayRole" caption="Role" width="200"></dxi-column>
            <dxi-column dataField="notes"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-success me-1" (click)="open()" *ngIf="!readOnly">Add</button>
                <button
                    class="btn btn-sm btn-primary me-1"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    *ngIf="!readOnly"
                >
                    Edit
                </button>
                <button
                    class="btn btn-sm btn-danger me-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    *ngIf="!readOnly"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'"></div>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="contact-grid"></dxo-state-storing>
        </dx-data-grid>
    `,
    styles: [],
    standalone: false
})
export class ContactGridComponent implements OnInit {
    uow = inject(GenesisUnitOfWork);
    auth = inject(AuthService);
    modalService = inject(BsModalService);
    appInfo = inject(AppInformationService);

    onToolbarPreparing = onToolbarPreparing;

    @Input() entityId: number;
    @Input() entityType: 'Dealer' | 'Vendor';
    @Input() readOnly: boolean;
    contacts: Contact[] = [];
    contactRoles: ContactRole[] = [];

    async ngOnInit() {
        this.contactRoles = await this.uow.contactRoles.whereActive('displayOrder, name');
        await this.getData();
    }

    async getData() {
        this.contacts = await this.uow.getContacts(this.entityId, this.entityType);
    }

    async open(contact?: Contact) {
        const modalRef = this.modalService.show(ContactDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                entityId: this.entityId,
                entityType: this.entityType,
                contact: contact,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.appInfo.pleaseWaitShow();
                await this.uow.commit([result.value]);
                await this.getData();
                await this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }

    async delete(contact: Contact) {
        if (!contact) return;

        const result = await confirm('Are you sure you want to delete this contact?', 'Delete Contact');
        if (!result) return;

        await this.appInfo.pleaseWaitShow();
        contact.deleted = new Date();
        contact.deletedBy = this.auth.currentUser.userName;
        await this.uow.commit([contact]);
        await this.getData();
        await this.appInfo.pleaseWaitHide();
    }
}
